import { Injectable } from '@angular/core';
import {
  CreateRewardsPreference,
  LoadRewardsPreference,
} from '@features/rewards-preference/store/actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  getCreateRewardsPreferenceError,
  getCreateRewardsPreferenceLoading,
  getCreateRewardsPreferenceSuccess,
  getLoadRewardsPreferenceError,
  getLoadRewardsPreferenceLoading,
  getLoadRewardsPreferenceSuccess,
  getRewardsPreference,
} from '../../store/selectors/rewards-preference.selectors';
import {
  CreateRewardsPreferenceWithLoyaltyProgram,
  CreateRewardsPreferenceWithMembership,
  RewardsPreference,
  RewardsPreferenceType,
} from '../../types/rewards-preference.type';

@Injectable({
  providedIn: 'root',
})
export class RewardsPreferenceFacade {
  constructor(private store: Store) {}

  rewardsPreference$: Observable<RewardsPreference | null> =
    this.store.select(getRewardsPreference);

  // get
  getRewardsPreferenceLoading$: Observable<boolean> = this.store.select(
    getLoadRewardsPreferenceLoading,
  );

  getRewardsPreferenceSuccess$: Observable<boolean> = this.store.select(
    getLoadRewardsPreferenceSuccess,
  );

  getRewardsPreferenceError: Observable<boolean> = this.store.select(
    getLoadRewardsPreferenceError,
  );

  // create
  getCreateRewardsPreferenceLoading$: Observable<boolean> = this.store.select(
    getCreateRewardsPreferenceLoading,
  );

  getCreateRewardsPreferenceSuccess$: Observable<boolean> = this.store.select(
    getCreateRewardsPreferenceSuccess,
  );

  getCreateRewardsPreferenceError$: Observable<boolean> = this.store.select(
    getCreateRewardsPreferenceError,
  );

  // methods
  loadRewardsPreference(): void {
    this.store.dispatch(new LoadRewardsPreference());
  }

  createRewardsPreference(payload: {
    rewardsPreference: RewardsPreferenceType;
    membership:
      | CreateRewardsPreferenceWithMembership
      | CreateRewardsPreferenceWithLoyaltyProgram;
  }): void {
    this.store.dispatch(new CreateRewardsPreference(payload));
  }
}
